var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6266 5.97381C14.5558 5.96705 14.4849 5.96705 14.4142 5.97381C13.4096 5.92324 12.6162 5.09434 12.6162 4.07499C12.6162 3.02501 13.4685 2.16666 14.5245 2.16666C15.574 2.16666 16.432 3.01808 16.4329 4.07342C16.4255 5.09504 15.6301 5.92327 14.6266 5.97381Z",
    fill: "#86A7C3",
    stroke: "#86A7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0467 11.8344L17.0465 11.8345C16.3903 12.274 15.4939 12.5032 14.5857 12.498C14.7658 11.9321 14.8599 11.3325 14.8663 10.7135L14.8663 10.7135V10.7083C14.8663 10.0583 14.7638 9.42725 14.5628 8.83965C15.4822 8.83122 16.3779 9.06061 17.0398 9.49992L17.0398 9.49993L17.0414 9.50098C17.5953 9.86557 17.8042 10.2972 17.8049 10.6644C17.8056 11.0323 17.5976 11.4659 17.0467 11.8344Z",
    fill: "#86A7C3",
    stroke: "#86A7C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56016 5.97381C5.48944 5.96705 5.4185 5.96705 5.34779 5.97381C4.34322 5.92324 3.5498 5.09434 3.5498 4.07499C3.5498 3.01667 4.40208 2.16666 5.4498 2.16666C6.507 2.16666 7.35814 3.0178 7.35814 4.07499C7.35814 5.09434 6.56472 5.92324 5.56016 5.97381Z",
    fill: "#86A7C3",
    stroke: "#86A7C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45794 10.7083C5.45794 11.5167 5.63294 12.2833 5.94961 12.975C4.77461 13.1 3.54961 12.85 2.64961 12.2583C1.33294 11.3833 1.33294 9.95834 2.64961 9.08334C3.54128 8.48334 4.79961 8.24167 5.98294 8.37501C5.64128 9.07501 5.45794 9.86667 5.45794 10.7083Z",
    fill: "#86A7C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 13.225C10.0333 13.2167 9.95833 13.2167 9.88333 13.225C8.35 13.175 7.125 11.9167 7.125 10.3667C7.13333 8.78333 8.40833 7.5 10 7.5C11.5833 7.5 12.8667 8.78333 12.8667 10.3667C12.8583 11.9167 11.6417 13.175 10.1 13.225Z",
    fill: "#86A7C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39199 14.95C6.13366 15.7917 6.13366 17.175 7.39199 18.0083C8.82533 18.9667 11.1753 18.9667 12.6087 18.0083C13.867 17.1667 13.867 15.7833 12.6087 14.95C11.1837 13.9917 8.83366 13.9917 7.39199 14.95Z",
    fill: "#86A7C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.dc725505.svg";
export { ForwardRef as ReactComponent };